<template>
  <div class="ushk-content">
    <div class="hd">权限详情</div>
    <div class="bd">
      <div>
        <span>存储</span>
        开启存储权限，方便您下载和更新应用
      </div>
      <div>
        <span>照相机</span>
        允许应用访问设备的日历数据。此权限用于应用展示日历相关功能
      </div>
      <div>
        <span>电话</span>
        获取设备的标识
      </div>
      <div>
        <span>位置</span>
        给用户精准推送消息
      </div>
    </div>
  </div>
</template>
<script>
import { device } from "@/commons";

export default {
  name: "Home",
  data() {
    return {};
  },
  mounted() {
    if (device.isMobile) {
      new Jin10AppLauncher({
        openBlank: true,
        website: "futures",
      });
    }
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/helpers/_function.scss";

.ushk-content {
  margin-top: 20px;
  margin-bottom: 0;
  border-radius: 4px;
  border: 1px solid #e7eaf2;
  background: #fff;

  .hd {
    padding: 50px 120px 20px;
    font-size: 26px;
    line-height: 37px;
    font-weight: 500;
    color: #000;
    border-bottom: 1px solid #eee;
  }
  .bd {
    padding: 0 120px 50px;
    font-size: 16px;
    color: #3d4351;
    line-height: 32px;

    span {
      display: block;
      margin-top: 20px;
      font-weight: 600;
      color: #000;
    }
  }

  @include max-screen(768px) {
    .hd {
      padding: 20px;
      font-size: 20px;
      line-height: 32px;
    }
    .bd {
      padding: 0 20px 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// home.vue?670b5cca